module.exports = __webpack_public_path__ + "static/media/tutorial3.49b76061.svg";